import { exportToCsv, type CsvColumn } from "@client-shared/utils";
import { readableBatchId } from "@client-shared/lib/util";
import type { LabelPrintBatch } from "@shared/types";
import type { TFunction } from "i18next";

type BatchCsvRow = Record<string, unknown>;

export function exportBatchesToCsv(batches: LabelPrintBatch[], t: TFunction): void {
  const rows: BatchCsvRow[] = batches.map((batch) => ({
    ...batch,
    batchId: readableBatchId(batch.batchId),
  }));

  const columns: CsvColumn<BatchCsvRow>[] = [
    { key: "batchId", header: t("views.batches.exportColumns.batchId") },
    {
      key: "batchStatus",
      header: t("views.batches.exportColumns.batchStatus"),
    },
    { key: "createdAt", header: t("views.batches.exportColumns.createdAt") },
    {
      key: "batchNotes",
      header: t("views.batches.exportColumns.batchNotes"),
    },
    {
      key: "totalOrders",
      header: t("views.batches.exportColumns.totalOrders"),
    },
    { key: "totalUnits", header: t("views.batches.exportColumns.totalUnits") },
    {
      key: "totalWeightInGrams",
      header: t("views.batches.exportColumns.totalWeightInGrams"),
    },
    {
      key: "labelCreatedOrders",
      header: t("views.batches.exportColumns.labelCreatedOrders"),
    },
    {
      key: "failedForRetryOrders",
      header: t("views.batches.exportColumns.failedForRetryOrders"),
    },
    {
      key: "totalLabelPrintAttempts",
      header: t("views.batches.exportColumns.totalLabelPrintAttempts"),
    },
  ];

  exportToCsv({
    data: rows,
    filename: "batches",
    columns: columns as unknown as CsvColumn<Record<string, unknown>>[],
  });
}
